import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/service/sites')({
  staticData: { crumb: 'serviceSites' },
  component: Outlet,
})
